import { DATE_FORMATS_INTL, formatDate } from '../constants'
import { type Transaction } from '../types'
import type { SpendingFeeTransaction, MonthlyHealthScoreItem } from '../../core/types/Finstrong'

export const augmentChartData = (averageHealthScores: MonthlyHealthScoreItem[]) => {
  return averageHealthScores
    .sort((a, b) => {
      // Sort by year first, then by month
      if (a.monthly_health_score_average.year !== b.monthly_health_score_average.year) {
        return a.monthly_health_score_average.year - b.monthly_health_score_average.year
      }
      return a.monthly_health_score_average.month - b.monthly_health_score_average.month
    })
    .map((item) => ({
      x: formatDate(
        new Date(0, item.monthly_health_score_average.month - 1, 1),
        DATE_FORMATS_INTL.MONTH_SHORT,
      ),
      y: Math.round(item.monthly_health_score_average.average_health_score),
    }))
}

export const augmentSpendingFeeTransactions = (
  spendingFeeTransactions: SpendingFeeTransaction[],
): Transaction[] => {
  const organizedSpendingFeeTransactions = spendingFeeTransactions
    .map(({ transaction }: SpendingFeeTransaction) => {
      return {
        ...transaction,
      }
    })
    .sort((a, b) => b.date - a.date)

  return organizedSpendingFeeTransactions
}
